import { useEffect, useState, useRef } from 'react'
import { ConvertPriceToString } from '../../../../Helpers/CustomConverter';
import useGetProductPrices from '../../../../Components/BasketPage/Hooks/useGetProductPrices';
import { handleInputForQtyAndValueFocus, handleInputKeyPressForQtyAndValueInput, handleOnChangeForQtyAndValueInput } from '../../../../Helpers/PriceAndValueInputHelpers';
import { useFavoriteProducts } from '../../../../Providers/FavoriteProductsProvider';
import { useParams } from '../../../../Providers/ParamsProvider';
import ProductThreshold from '../../../../Components/Components/ProductThreshold';
import { useCart } from '../../../../Providers/CartProvider';
import useCommonFunctions from '../../Hooks/MobileAndDesktopCommon/useCommonFunctions';

/**
 * ES (DK:EDIT) : Komponent manipulacji ilością w koszyky
 * @param {object} product - Produkt
 * @param {boolean} isBasketSummary - Czy jest to podsumowanie koszyka
 * @param {boolean} isProductDetail - Czy jest to wywołanie z szczegółu produktu
 * @param {boolean} blockSetPriceFromBasket - Blokuje ustawienie ceny z koszyka na lost focus inputa z ilością
 * @param {boolean} isSavedBasket - Wejście z szybkokoszyka
 */
const ProductBuyBtn = ({ product, quantityInCart, quantity, setQuantity, OnChange, onClick, isBasketSummary, isProductDetail, blockSetPriceFromBasket, isSavedBasket,
    handleAddToCartFromSavedBasket }) => {
    const inputRef = useRef(null)
    const { getGrossValue, round2 } = useCart()
    const { selectedProducts, setSelectedProducts } = useFavoriteProducts()
    const { priceNet } = useGetProductPrices(product)
    const [priceNetTotal, setPriceNetTotal] = useState(0)
    const [priceGrossTotal, setPriceGrossTotal] = useState(0)
    const decimalPlaces = product.decimalPlaces
    const { isMobile } = useParams()
    const { checkIfProductCanBeAddedWithQuantity, getCartIconBackgroundColor, generateCartIcon } = useCommonFunctions()

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.value = parseFloat(inputRef.current.value).toFixed(decimalPlaces)
            calculateTotalPriceNetAndGross(inputRef.current.value)
        }
    }, [quantity])

    useEffect(() => {
        //Tutaj reagujemy na zmiane cen hurtowych
        calculateTotalPriceNetAndGross(quantity)
    }, [priceNet])

    const handleInputKeyPress = (event) => {
        if (!handleInputKeyPressForQtyAndValueInput(event, decimalPlaces)) {
            event.preventDefault()
            return
        }
    }

    const handleInputOnChange = (e) => {
        if (!checkIfProductCanBeAddedWithQuantity(e.target.value, product)) {
            return
        }
        if (!handleOnChangeForQtyAndValueInput(e, decimalPlaces, product.salesRatio)) {
            e.preventDefault()
            return
        }
        calculateTotalPriceNetAndGross(parseFloat(e.target.value))
        OnChange(e)
    }
    const calculateTotalPriceNetAndGross = (basketQty) => {
        let priceNetTotal = basketQty * parseFloat(priceNet)
        let priceGrossTotal = getGrossValue(priceNet, basketQty, product.taxRate)
        setPriceNetTotal(priceNetTotal)
        setPriceGrossTotal(priceGrossTotal)
    }

    const handleOnKeyDown = (e) => {
        if (isMobile) {
            if (['Enter', 'Go', 'Done', 'Next', 'Send', "Tab"].includes(e.key)) {
                e.preventDefault()
                onClick(quantityInCart > 0 ? 'update' : 'add')
                return
            }
        }
        else if (e.key === 'Enter') {
            onClick(quantityInCart > 0 ? 'update' : 'add')
        }
    }

    const handleInputLostFocus = (e) => {
        let qtyToShow = quantityInCart > 0 ? quantityInCart : (product.salesRatio > 0 ? product.salesRatio : 1)
        setQuantity(qtyToShow !== 0 ? round2(parseFloat(qtyToShow)) : round2(parseFloat(0)))
        if (!blockSetPriceFromBasket) {
            if (quantityInCart === 0) {
                const tmpSaleRatio = product.salesRatio > 0 ? product.salesRatio : 1
                setPriceNetTotal(round2(tmpSaleRatio * parseFloat(priceNet)))
                setPriceGrossTotal(round2(getGrossValue(priceNet, tmpSaleRatio, product.taxRate)))
            }
            else {
                const netValue = quantity * parseFloat(priceNet)
                let grossValue = getGrossValue(priceNet, quantity, product.taxRate)
                setPriceNetTotal(round2(netValue))
                setPriceGrossTotal(round2(grossValue))
            }
        }
        else {
            if (isNaN(e.target.value) || e.target.value === '' || e.target.value == 0) {
                const netValue = quantity * parseFloat(priceNet)
                let grossValue = getGrossValue(priceNet, quantity, product.taxRate)
                setPriceNetTotal(round2(netValue))
                setPriceGrossTotal(round2(grossValue))
            }
            else {
                e.target.value = parseFloat(e.target.value).toFixed(decimalPlaces)
            }
        }
    }

    const addToBasketButtonVisibility = isBasketSummary ? 'collapse' : ''
    const summarySectionVisibility = isProductDetail ? 'd-none' : ''
    const summarySectionStyle = isMobile ? 'align-items-start' : 'align-items-end'
    const inputStyle = isProductDetail || isMobile ? 'd-flex justify-content-start' : 'd-flex justify-content-end me-2'
    const salesRatioStyle = isProductDetail || isMobile ? 'd-flex justify-content-start' : 'd-flex justify-content-end'
    const salesRatioVisibility = product && product.salesRatio && product.salesRatio > 0 ? '' : 'd-none'
    const baseUnit = product && product.baseUnit ? product.baseUnit.toLowerCase() : product.baseUnit
    const stepValue = product.salesRatio && product.salesRatio > 0 ? product.salesRatio : 1
    const productDisplayMode = localStorage.getItem("productDisplayMode")
    const quantityTextColor = quantityInCart > 0 ? 'black' : 'var(--secondary)'
    const totalNet = ConvertPriceToString(priceNetTotal, product.currency)
    const totalGross = ConvertPriceToString(priceGrossTotal, product.currency)
    const netSummaryTextColor = quantityInCart > 0 ? 'black' : 'var(--secondary)'

    if (isMobile && productDisplayMode != 1) {
        return (<div className='d-flex flex-column'>
            <div className="row">
                <ProductThreshold
                    product={product}
                    isProductDetail={false}
                />
            </div>
            <div className="row mt-3">
                <div className={`${salesRatioVisibility} ${salesRatioStyle}`}>
                    <span className='secondary-text'>{`Pakiet sprzedażowy: ${product.salesRatio} ${baseUnit}`}</span>
                </div>
                <div className="col-4 d-flex">
                    <form onSubmit={(e) => { e.preventDefault(); handleOnKeyDown(e) }}>
                        <input
                            type="number"
                            enterKeyHint="done"
                            className='quantity-input-mobile'
                            value={quantity}
                            style={{ color: quantityTextColor }}
                            onChange={(e) => handleInputOnChange(e)}
                            onKeyPress={(e) => handleInputKeyPress(e)}
                            onFocus={handleInputForQtyAndValueFocus}
                            onKeyDown={handleOnKeyDown}
                            onBlur={handleInputLostFocus}
                            step={stepValue}
                            ref={inputRef}
                        />
                    </form>

                    <div className={`${addToBasketButtonVisibility} add-to-cart-icon-mobile`} style={{ backgroundColor: getCartIconBackgroundColor(quantityInCart, quantity) }}
                        onMouseDown={() => onClick(quantityInCart > 0 ? 'update' : 'add')}>
                        {generateCartIcon(10, quantityInCart, quantity)}
                    </div>
                    {/* {isSavedBasket && handleAddToCartFromSavedBasket &&
                        <div className='add-to-cart-icon-mobile' style={{ backgroundColor: quantityInCart > 0 ? 'var(--primary)' : 'white' }}
                            onClick={() => handleAddToCartFromSavedBasket(product, quantity)}>
                            <TbShoppingCartPlus style={{ color: quantityInCart > 0 ? 'white' : 'var(--primary)' }} size={10} />
                        </div>} */}
                </div>
            </div>
            <div className="row mt-3">
                <div className="col d-flex flex-column">
                    <span className='secondary-text'>Cena</span>
                    <b style={{ color: netSummaryTextColor }}>{totalNet}</b>
                    <div className='d-flex'>
                        <span className='secondary-text'>{totalGross}</span>
                        <span className='secondary-text ms-2'>{`${product.taxRate}%`}</span>
                    </div>
                </div>
            </div>
        </div>)
    }
    else {
        return (
            <>
                <div className='d-flex flex-column'>
                    <div className={`${salesRatioVisibility} ${salesRatioStyle}`}>
                        <span className='light-text-color'>{`Pakiet sprzedażowy: ${product.salesRatio} ${baseUnit}`}</span>
                    </div>
                    <div className={inputStyle}>
                        <input type='number'
                            className='biggerArrows quantity-input'
                            value={quantity}
                            style={{ maxWidth: '60%', color: quantityTextColor }}
                            onChange={(e) => handleInputOnChange(e)}
                            onKeyPress={(e) => handleInputKeyPress(e)}
                            onFocus={handleInputForQtyAndValueFocus}
                            onKeyDown={handleOnKeyDown}
                            onBlur={handleInputLostFocus}
                            step={stepValue}
                            ref={inputRef}
                        />

                        <div className={`${addToBasketButtonVisibility} add-to-cart-icon`} style={{ backgroundColor: getCartIconBackgroundColor(quantityInCart, quantity) }}
                            onMouseDown={() => onClick(quantityInCart > 0 ? 'update' : 'add')}>
                            {generateCartIcon(20, quantityInCart, quantity)}
                        </div>
                        {/* {isSavedBasket && handleAddToCartFromSavedBasket &&
                            <div className='add-to-cart-icon' style={{ backgroundColor: quantityInCart > 0 ? 'var(--primary)' : 'white' }}
                                onClick={() => handleAddToCartFromSavedBasket(product, quantity)}>
                                <TbShoppingCartPlus style={{ color: quantityInCart > 0 ? 'white' : 'var(--primary)' }} size={20} />
                            </div>} */}
                    </div>
                    <div className={`${summarySectionVisibility} me-2`}>
                        <div className={`d-flex flex-column ${summarySectionStyle}`}>
                            <b style={{ color: netSummaryTextColor }}>{`Razem: ${totalNet}`}</b>
                            <span className='light-text-color'>{`${totalGross} brutto (${product.taxRate}%)`}</span>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default ProductBuyBtn
